// Clamp — "Show more / Show less" toggle for truncated content
(function () {
  window._cc = window._cc || {};

  function isOverflowing(el) {
    return el.scrollHeight > el.clientHeight + 1;
  }

  // Show or hide each toggle based on whether its target is actually clamped.
  // Called both on init and whenever hidden content becomes visible (e.g. slide changes).
  //
  // NOTE: .clamp must be directly on the text element (no child wrappers).
  // A nested div's margins inflate scrollHeight, making isOverflowing() return
  // true even when the text fits — the toggle shows on single-line text.
  function initToggles() {
    document.querySelectorAll('[data-clamp-toggle]').forEach(function (btn) {
      var target = btn.previousElementSibling;
      if (!target || !target.classList.contains('clamp')) return;
      btn.style.display = isOverflowing(target) ? '' : 'none';
    });
  }

  // Toggle expand/collapse
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-clamp-toggle]');
    if (!btn) return;

    var target = btn.previousElementSibling;
    if (!target || !target.classList.contains('clamp')) return;

    var expanded = target.classList.toggle('clamp--expanded');
    btn.textContent = expanded ? 'Show less' : 'Show more';
  });

  // Run after fonts are loaded so overflow is measured with the real typeface.
  // Falls back to DOMContentLoaded if the Fonts API is unavailable.
  function run() {
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(initToggles);
    } else {
      initToggles();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  document.addEventListener('htmx:afterSettle', function(e) {
    initToggles();
    e.target.querySelectorAll('[data-clamp]').forEach(initClamp);
    e.target.querySelectorAll('[data-clamp-list]').forEach(applyClampList);
  });

  // Expose so other scripts can re-run after making hidden content visible
  window.clampInitToggles = initToggles;

  // ====================================================================
  // Collapse — toggle visibility of structured content blocks
  // ====================================================================
  // Handles both:
  //   1. .collapse-toggle[data-collapse-target="#id"] — generic collapse
  //   2. .card--collapsible .card__title[data-collapse-target] — collapsible card

  // Interactive elements that own their own click. Used to keep a nested
  // control (edit link, dropdown, checkbox) from also toggling the row it
  // sits in — see the guard below.
  var INTERACTIVE = 'button, a, input, select, textarea, label, summary,' +
    ' [data-sheet], [data-dropdown], .dropdown-menu, [hx-get], [hx-post]';

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-collapse-target]');
    if (!trigger) return;

    // Bail when the click landed on an interactive element nested INSIDE the
    // trigger — a button in an expandable row should act on its own, not also
    // expand the row. The `!== trigger` test matters: the trigger is often a
    // <button class="collapse-toggle"> itself, and that must still toggle.
    var interactive = e.target.closest(INTERACTIVE);
    if (interactive && interactive !== trigger && trigger.contains(interactive)) return;

    var targetSelector = trigger.getAttribute('data-collapse-target');

    // Card collapsible — toggle on the card element (only when the title itself is the trigger)
    var card = trigger.closest('.card--collapsible');
    if (card && trigger.matches('.card__title')) {
      var isOpening = !card.classList.contains('collapse--open');
      card.classList.toggle('collapse--open');

      // Accordion: close sibling panels when one opens
      if (isOpening) {
        var accordion = card.closest('[data-accordion]');
        if (accordion) {
          accordion.querySelectorAll('.card--collapsible.collapse--open').forEach(function (sibling) {
            if (sibling !== card) sibling.classList.remove('collapse--open');
          });
        }
      }
      return;
    }

    // Generic collapse — supports comma-separated selectors for multi-target toggle
    if (!targetSelector) return;
    // A sheet or modal usually renders the same partial — and so the same ids —
    // as the page behind it. Resolve within the trigger's own overlay first, so
    // a toggle inside a sheet can't reach the duplicate id underneath it.
    var scope = trigger.closest('.sheet, .modal');
    var selectors = targetSelector.split(',');
    var targets = selectors.map(function (s) {
      s = s.trim();
      return (scope && scope.querySelector(s)) || document.querySelector(s);
    }).filter(Boolean);
    if (!targets.length) return;

    targets.forEach(function (t) { t.classList.toggle('collapse--open'); });
    var isOpen = targets[0].classList.contains('collapse--open');
    trigger.classList.toggle('collapse-toggle--open', isOpen);
    trigger.setAttribute('aria-expanded', String(isOpen));

    // Update button text if data attributes provided
    var showText = trigger.getAttribute('data-collapse-show');
    var hideText = trigger.getAttribute('data-collapse-hide');
    if (showText && hideText) {
      // Update only the text node, preserve child elements (icons)
      var textNode = trigger.firstChild;
      if (textNode && textNode.nodeType === 3) {
        textNode.textContent = isOpen ? hideText : showText;
      }
    }
  });

  // ====================================================================
  // JS-driven clamp — [data-clamp="N"]
  // ====================================================================
  // Measures scrollHeight and sets maxHeight inline. Auto-creates a toggle
  // link. Better than CSS clamp for dynamic/HTMX content where you can't
  // pre-place a toggle button.

  function initClamp(el) {
    if (el.hasAttribute('data-clamp-init')) return;
    el.setAttribute('data-clamp-init', '');

    var lines = parseInt(el.getAttribute('data-clamp')) || 4;
    var lineHeight = parseFloat(getComputedStyle(el).lineHeight) || 20;
    var maxH = lines * lineHeight;
    var isTextarea = el.tagName === 'TEXTAREA';

    setTimeout(function () {
      if (el.scrollHeight <= maxH + 4) return;

      el.style.maxHeight = maxH + 'px';
      el.style.overflow = 'hidden';

      var toggle = document.createElement('a');
      toggle.href = '#';
      toggle.className = 'clamp-toggle text-coral';
      toggle.textContent = 'Show more';
      toggle.setAttribute('data-clamp-toggle', '');
      el.parentNode.insertBefore(toggle, el.nextSibling);

      var userExpanded = false;

      toggle.addEventListener('click', function (e) {
        e.preventDefault();
        if (el.style.maxHeight) {
          el.style.maxHeight = '';
          el.style.overflow = '';
          if (isTextarea && window._cc.autoResize) window._cc.autoResize(el);
          toggle.textContent = 'Show less';
          userExpanded = true;
        } else {
          el.style.maxHeight = maxH + 'px';
          el.style.overflow = 'hidden';
          toggle.textContent = 'Show more';
          userExpanded = false;
        }
      });

      if (isTextarea) {
        el.addEventListener('focus', function () {
          el.style.maxHeight = '';
          el.style.overflow = '';
          if (window._cc.autoResize) window._cc.autoResize(el);
          toggle.textContent = 'Show less';
        });

        el.addEventListener('blur', function () {
          if (window._cc.autoResize) window._cc.autoResize(el);
          if (userExpanded) return;
          if (el.scrollHeight > maxH + 4) {
            el.style.maxHeight = maxH + 'px';
            el.style.overflow = 'hidden';
            toggle.textContent = 'Show more';
          } else {
            el.style.maxHeight = '';
            toggle.style.display = 'none';
          }
        });
      }
    }, 0);
  }

  document.querySelectorAll('[data-clamp]').forEach(initClamp);

  // ====================================================================
  // JS-driven list clamp — [data-clamp-list="N"]
  // ====================================================================
  // Shows only N items in a list, with a "Show N more" toggle link.
  // Works with filter: restores clamp-hidden items first, then re-applies
  // limit to whatever the filter left visible.

  function applyClampList(el) {
    if (!el || !el.hasAttribute('data-clamp-list')) return;
    var limit = parseInt(el.getAttribute('data-clamp-list')) || 5;
    var expanded = el.hasAttribute('data-clamp-expanded');

    // Restore items hidden by clamp (not by filter).
    // Don't touch display — the filter already owns it when active.
    el.querySelectorAll('[data-clamp-hidden]').forEach(function (item) {
      item.removeAttribute('data-clamp-hidden');
    });

    // Remove existing toggle
    var existing = el.querySelector('.clamp-list-toggle');
    if (existing) existing.remove();

    // Collect items visible after filter
    var childSelector = el.getAttribute('data-clamp-list-child') || ':scope > :not(.clamp-list-toggle)';
    var items = el.querySelectorAll(childSelector);
    var visible = [];
    items.forEach(function (item) {
      if (item.style.display !== 'none') visible.push(item);
    });

    if (visible.length <= limit) return;

    var hiddenCount = visible.length - limit;

    if (!expanded) {
      for (var i = limit; i < visible.length; i++) {
        visible[i].setAttribute('data-clamp-hidden', '');
      }
    }

    var toggle = document.createElement('a');
    toggle.href = '#';
    toggle.className = 'clamp-list-toggle clamp-toggle text-coral';
    toggle.textContent = expanded ? 'Show less' : 'Show ' + hiddenCount + ' more';
    el.appendChild(toggle);

    toggle.addEventListener('click', function (e) {
      e.preventDefault();
      if (el.hasAttribute('data-clamp-expanded')) {
        el.removeAttribute('data-clamp-expanded');
      } else {
        el.setAttribute('data-clamp-expanded', '');
      }
      applyClampList(el);
    });
  }

  document.querySelectorAll('[data-clamp-list]').forEach(applyClampList);

  // Expose for other modules
  window._cc.initClamp = initClamp;
  window._cc.applyClampList = applyClampList;

})();
